// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6289":"6ea6f1f2","8759":"2a37894b"}[chunkId] + ".chunk.css";
};